import { Navigate, Outlet, useLocation } from "react-router-dom";

export function ExpertPrivateLayout() {
  // 🟢 FIXED: Match the exact camelCase key your login hook uses!
  const expertCode = localStorage.getItem('expertCode'); 
  const location = useLocation();

  // 🟢 The Bouncer
  if (!expertCode) {
    return <Navigate to="/expert-login" replace state={{ from: location }} />;
  }

  // 🟢 The Blank Canvas Layout 
  return (
    <div className="min-h-screen bg-gray-100">
      <Outlet />
    </div>
  );
}